import { PageShell } from "../../ui";
import AppStatusSection from "./components/AppStatusSection";
import TrafficSection from "./components/TrafficSection";

/** Superadmin: uptime of every Inflos app, and traffic on the marketplace. */
export default function Platform() {
  return (
    <PageShell title="Platform" subtitle="Whether every Inflos app is up, and how many people are visiting inflos.co">
      <AppStatusSection />
      <TrafficSection />
    </PageShell>
  );
}
